import React from "react";
import RequestNewExamState, { RequestNewExamProps } from "./RequestNewExam.models";
import './RequestNewExam.scss';
import RequestExamImage from "../../../assest/images/card-image/item-pencil-avatar@3x.png";
import SelectInput from "../../shared/select/SelectInput";
import StudentBaseService from "../../../services/education/StudentBaseService";
import CourseService from "../../../services/education/CourseService";
import CourseChapterService from "../../../services/education/CourseChapterService";
import ExamResultService from "../../../services/exam/ExamResultService";
import AuthContext from "../../../contexts/AuthContext";
import PanelUpgradeModal from "../../shared/panel-upgrade-modal/PanelUpgradeModal";
import { StudentStatus } from "../../../models/interfaces/student/StudentStatus";

export default class RequestNewExam extends React.PureComponent<RequestNewExamProps, RequestNewExamState> {

    studentBaseService: StudentBaseService;
    courseService: CourseService;
    courseChapterService: CourseChapterService;
    examResultService: ExamResultService;
    static contextType = AuthContext

    constructor(props: any) {
        super(props);
        this.studentBaseService = new StudentBaseService();
        this.courseService = new CourseService();
        this.courseChapterService = new CourseChapterService();
        this.examResultService = new ExamResultService();
        this.state = { exams: [], courseChapters: [], courses: [], studentBases: [], basicInformation: {}, showUpgradeModal: false, studentSystemInformation: {} };

    }

    componentDidMount = () => {
        let self = this;

        this.setState({ studentSystemInformation: this.context.userInformation.system });

        self.getStudentBase();
    }

    componentDidUpdate = () => {
        this.setState({ studentSystemInformation: this.context.userInformation.system });

    }

    getStudentBase() {
        let self = this;

        self.studentBaseService.getBaseTitleValueByStudentId().then(function (response) {
            self.setState({ studentBases: response });
        })
    }

    getCourse(value: any) {
        let self = this;

        if (value !== null && value !== "" && value !== undefined) {

            self.setState({ courses: [], courseChapters: [], exams: [] });
            self.courseService.getTitleValueCoursesActive(value, this.context.userInformation.education.fieldId).then(function (response) {
                self.setState({ courses: response });
            })
        }
    }

    getCourseChapter(value: any) {
        let self = this;

        if ((value !== null && value !== "" && value !== undefined) && (self.state.basicInformation.studentBaseId !== null && self.state.basicInformation.studentBaseId !== 0 && self.state.basicInformation.studentBaseId !== undefined)) {

            self.setState({ courseChapters: [], exams: [] });
            self.courseChapterService.getTitleValueByCourseId({ baseID: self.state.basicInformation.studentBaseId, fieldID: this.context.userInformation.education.fieldId, courseID: value }).then(function (response) {
                self.setState({ courseChapters: response });
            })
        }
    }

    getExams(value?: any, courseId?: any) {
        let self = this;

        if ((self.state.basicInformation.studentBaseId !== null && self.state.basicInformation.studentBaseId !== 0 && self.state.basicInformation.studentBaseId !== undefined)
        ) {

            self.examResultService.getExamEntrance({
                studentBaseId: self.state.basicInformation.studentBaseId,
                studentFieldId: this.context.userInformation.education.fieldId,
                courseChapterId: value,
                courseId: self.state.basicInformation.courseId ?? courseId
            }).then(function (response) {
                self.setState({ exams: response });
            })
        }
    }


    setBaseSelected = (value: any) => {
        let self = this;
        this.setState((prevState) => {
            return { basicInformation: { ...prevState.basicInformation, studentBaseId: value } }
        });

        if (value !== null && value !== "" && value !== undefined) {
            self.getCourse(value);
        }
        else
            self.setState({ courses: [], courseChapters: [], exams: [] });
    }

    setCourseSelected = (value: any) => {
        let self = this;
        this.setState((prevState) => {
            return { basicInformation: { ...prevState.basicInformation, courseId: value } }
        });
        if (value !== null && value !== "" && value !== undefined) {
            self.getExams('', value);
            self.getCourseChapter(value);
        }
        else
            self.setState({ courseChapters: [], exams: [] });
    }

    setCourseChapterSelected = (value: any) => {
        let self = this;
        this.setState((prevState) => {
            return { basicInformation: { ...prevState.basicInformation, courseChapterId: value } }
        });

        if (value !== null && value !== "" && value !== undefined) {
            self.getExams(value);
        }
        else
            self.setState({ exams: [] });
    }

    setExamSelected = (value: any) => {
        this.setState((prevState) => {
            return { basicInformation: { ...prevState.basicInformation, examId: value } }
        });
    }

    requestExam = () => {
        let self = this;
        let request;

        if (self.state.basicInformation.courseId != null && self.state.basicInformation.courseChapterId != null && self.state.exams.length !== 0) {
            if (self.state.basicInformation.examId === 0 || self.state.basicInformation.examId === null || self.state.basicInformation.examId === undefined) {
                alert("آزمونی جهت ثبت انتخاب نشده است");
                return;
            }

            request = {
                examId: self.state.basicInformation.examId,
                preliminaryExam: {}
            };
        }
        else if (self.state.basicInformation.courseId != null && self.state.basicInformation.studentBaseId != null && self.state.basicInformation.examId != null) {
            request = {
                examId: self.state.basicInformation.examId,
                preliminaryExam: {}
            };
        }
        else if (self.state.basicInformation.studentBaseId != null) {
            request = {
                examId: null,
                preliminaryExam: {
                    baseId: self.state.basicInformation.studentBaseId,
                    courseChapterId: self.state.basicInformation.courseChapterId,
                    courseId: self.state.basicInformation.courseId,
                    fieldId: this.context.userInformation.education.fieldId
                }
            };
        };
        if (request) {
            self.examResultService.examRequest(request).then(function (response) {
                if (response){
                    window.location.href = `/RequestExamList`;
                    self.clear();
                }
            });

        }
    }

    clear() {
        let self = this;
        self.setState({ exams: [], courseChapters: [], courses: [], studentBases: [], basicInformation: {} });
    }

    render(): React.ReactNode {
        let { courseChapters, courses, studentBases, exams, basicInformation, showUpgradeModal, studentSystemInformation } = this.state;
        let examArea;
        let letRequestExam = studentSystemInformation.status === StudentStatus.Archive || studentSystemInformation.status === StudentStatus.InitialRegistration;
        if (basicInformation.courseId != null && basicInformation.courseChapterId != null && exams.length === 0) {
            examArea = (<div style={{ textAlign: 'center', fontSize: '14px', color: '#fb9905', }}>
                <label>آزمونی جهت نمایش وجود ندارد </label>
                <label>جهت ثبت درخواست برای آزمون پیش فرض بر روی ثبت درخواست کلیک کنید</label>
            </div>);
        }
        else if (exams !== null && exams !== [] && exams.length !== 0)
            examArea = ("");

        return (<>
            <div className="request-new-exam-area dropdown-list mt-2">
                <div className="tk-card">
                    <div className="col-12">
                        <div className="icon">
                            <img src={RequestExamImage} width="64" height="64" alt="request exam" />
                        </div>
                        <div className="title">
                            <label>درخواست آزمون</label>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="tk-boby">
                            <div className="bd-title">
                                <label>اطلاعات آزمون مورد نظر خود را انتخاب کنید</label>
                            </div>
                            <div className="exam-content">
                                <div className="tk-padding-bottom">
                                    <label htmlFor="studentBase">پایه:</label>
                                    <SelectInput inputvalue={this.state.basicInformation.studentBaseId} datas={studentBases} value={this.setBaseSelected} isNullAble={true} name='studentBase' />
                                </div>
                                <div className="tk-padding-bottom">
                                    <label htmlFor="course">درس:</label>
                                    <SelectInput inputvalue={this.state.basicInformation.courseId} datas={courses} value={this.setCourseSelected} isNullAble={false} name='course' />
                                </div>
                                <div className="tk-padding-bottom">
                                    <label htmlFor="courseChapter">سرفصل:</label>
                                    <SelectInput inputvalue={this.state.basicInformation.courseChapterId} datas={courseChapters} value={this.setCourseChapterSelected} isNullAble={true} name='courseChapter' />
                                </div>

                                <div className="tk-padding-bottom">
                                    <label htmlFor="exam">آزمون:</label>
                                    <SelectInput inputvalue={this.state.basicInformation.examId} datas={exams} value={this.setExamSelected} isNullAble={true} name='exam' />
                                </div>
                                {examArea}

                                <div className="col-12">
                                    <div className="row">
                                        <div className="col-12 notspace">
                                            <button onClick={() => letRequestExam ? this.setState({ showUpgradeModal: true }) : this.requestExam()} style={{ width: "100%" }} type="submit" className="btn btn-success">
                                                ثبت درخواست
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </div >

            <PanelUpgradeModal showModal={showUpgradeModal} closeModal={() => this.setState({ showUpgradeModal: false })} />
        </>)
    }
}


